export const canonBreakers = {
  8791: {
    name: 'Mizu (#8791)',
  },
  1801: {
    name: 'Eddy (#1801)',
  },
  1332: {
    name: 'Kain (#1332)',
  },
  1752: {
    name: 'Ophelia (#1752)',
  },
  1202: {
    name: 'Billy (#1202)',
  },
  676: {
    name: 'ElleKay (#676)',
  },
  8855: {
    name: 'Ayra Krats (#8855)',
  },
  6886: {
    name: 'Zard (#6886)',
  },
  2788: {
    name: 'Mango Hero (#2788)',
  },
  1136: {
    name: 'Joli (#1136)',
  },
  934: {
    name: 'Novah (#934)',
  },
  1153: {
    name: 'Kenny (#1153)',
  },
  7548: {
    name: 'Yuzu (#7548)',
  },
};

type CanonBreakerId = keyof typeof canonBreakers;

export const isCanonBreaker = (id: number): id is CanonBreakerId => {
  return Object.keys(canonBreakers).map(Number).includes(id);
};
